<script>
import { h } from 'vue';

export default {
  props: {
    value: Object,
  },
  render() {
    let hiddenFields = [];
    for (const [name, value] of Object.entries(this.value)) {
      const inputNode = h('input', { type: 'hidden', name, value });
      hiddenFields.push(inputNode);
    }
    return hiddenFields;
  },
};
</script>
